import cx from 'clsx';
import classes from './PinCodeInput.module.css';
import { type FunctionComponent } from 'react';
import {
  InputWrapper,
  InputWrapperProps,
  /* eslint-disable-next-line no-restricted-imports --
     This is a valid import of PinInput as this component is a wrapper around it */
  PinInput,
  PinInputProps,
  VisuallyHidden,
} from '@mantine/core';

export interface PinCodeInputProps
  extends
    Omit<PinInputProps, 'error'>,
    Pick<InputWrapperProps, 'label' | 'error' | 'description'> {}

/**
 * PinCodeInput wraps the regular Mantine PinInput component with InputWrapper so that it can
 * display error messages, labels and descriptions in the standard way.
 * @param param0
 * @returns
 */
const PinCodeInput: FunctionComponent<PinCodeInputProps> = ({
  className,
  label,
  description,
  ariaLabel,
  error,
  ...others
}) => {
  const visibleLabel = !!label;
  const internalLabel = label ?? ariaLabel ?? 'Pin code';
  const pinInputProps: PinInputProps = {
    ...others,
    error: !!error,
  };

  return (
    <InputWrapper
      component="fieldset"
      className={cx(className, classes.root)}
      error={error}
      description={description}>
      <legend
        className={cx('mantine-InputWrapper-label')}
        aria-label={ariaLabel}>
        {visibleLabel ? (
          internalLabel
        ) : (
          <VisuallyHidden>{internalLabel}</VisuallyHidden>
        )}
      </legend>
      <PinInput {...pinInputProps} ariaLabel={`${internalLabel} digit`} />
    </InputWrapper>
  );
};

export default PinCodeInput;
